import img1 from './Image/news1.png'
import img2 from './Image/news2.png'
import img3 from './Image/news3.png'
import './index.css';

const data = [
    {
        title: '[Opening Market] KOSPI Recovers 6,380 Level Amid Won/Dollar Rate Staying in Mid-1,420 Range',
        picture: img1,
    },
    {
        title: 'LG EXAONE Tops Industrial AI Global Rankings',
        picture: img2,
    },
    {
        title: 'New Mexico fines Meta $567 million over child safety | The Jerusalem Post',
        picture: img3,
    },

]


const ContentNewsPoster = () => {
    return (
        <div className='text-white'>
            {
                data.map((item, index) => <div className='mb-5' key={index}>
                    <p className='fw-bold text-center'>{item.title}</p>
                    <img className='imgeAI-image d-flex gap-2 flex-column justify-content-center align-items-center mx-auto' src={item.picture} alt={item.title}  ></img>
                </div>)
            }
        </div>
    );
};

export default ContentNewsPoster;